export const RECORD_STATUS = {
  0: { text: '充值已到账', color: 'success' },
  1: { text: '已提交', color: 'info' },
  2: { text: '已取消', color: 'disabled' },
  '-1': { text: '失败', color: 'danger' }
};
